import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import {
  HomePage, CategoriesPage, CategoryPage, ProductPage, SearchPage,
  AboutPage, NotFoundPage, CartPage, BadgeValidationPage, BadgeAdminPage,
  BadgeIntegrationPage, BadgeApplicationPage, PrivacyPolicyPage,
  TermsOfServicePage, BadgeDesignsPage, AdminPage, AdminProductsPage,
  AdminProductEditPage, AdminCategoriesPage, SavedPage,
  BrandsPage, BrandPage, ListsPage, ListPage, NewListPage, AccountPage
} from './pages';
import { CartProvider } from './contexts/CartContext';
import { ConfigProvider } from './hooks/useConfig';

function App() {
  return (
    <ConfigProvider>
      <CartProvider>
      <Router>
        <ScrollToTop />
        <MainLayout>
          <ScrollToTopButton />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/categories/:slug" element={<CategoryPage />} />
            <Route path="/p/:id/:slug" element={<ProductPage />} />
            <Route path="/products/:id" element={<ProductPage />} /> {/* Keep for backward compatibility */}
            <Route path="/search" element={<SearchPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/saved" element={<SavedPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/brands/:slug" element={<BrandPage />} />
            <Route path="/lists" element={<ListsPage />} />
            <Route path="/lists/new" element={<NewListPage />} />
            <Route path="/lists/:token" element={<ListPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/badge-validation" element={<BadgeValidationPage />} />
            <Route path="/badge-admin" element={<BadgeAdminPage />} />
            <Route path="/badge-integration" element={<BadgeIntegrationPage />} />
            <Route path="/badge-application" element={<BadgeApplicationPage />} />
            <Route path="/badge-designs" element={<BadgeDesignsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/products" element={<AdminProductsPage />} />
            <Route path="/admin/categories" element={<AdminCategoriesPage />} />
            <Route path="/admin/products/:action/:id?" element={<AdminProductEditPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </MainLayout>
      </Router>
      </CartProvider>
    </ConfigProvider>
  );
}

export default App;
